@import '~style-sheet-helpers/core.less';
@import (reference) '../../../settings-page.module.less';

@import '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.settings-resources-wrapper {
  display: flex;
  justify-content: flex-start;
}

.settings-resources-item {
  padding: @space-16;
  max-width: 392px;
  border-radius: 8px;
  background-color: var(--grey-000);
  border: 1px solid var(--grey-300);

  &:not(:last-of-type) {
    margin-right: @space-24;
  }
}
